import * as React from 'react';
import { Image } from '@cian/ui-kit';
import * as styles from './ResponsiveImage.css';

interface IResponsiveImageProps {
  src: string;
  alt?: string;
}

export const ResponsiveImage: React.FC<IResponsiveImageProps> = ({ src, alt }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['image-wrapper']}>
        <Image src={src} alt={alt} objectFit="cover" loading="lazy" />
      </div>
    </div>
  );
};
